<template>
  <modal
    name="bannerEdit"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
    @before-open="prepararFormulario"
  >
    <CloseModal :close="close" />
    <Loading :isActive="loading" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Informações">
            <StepInformacoes :item="item" :validacao="validation" />
          </CTab>
          <CTab title="Destino">
            <StepDestino :item="item" :validacao="validation" />
          </CTab>
          <CTab title="Imagens">
            <StepImagens :item="item" :validacao="validation" />
          </CTab>
          <CTab title="Exibição">
            <StepExibicao
              :item="item"
              :validacao="validation"
              :filiais="filiais"
              :sistemas="sistemas"
            />
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close">
        Cancelar
      </CButton>
      <CButton color="primary" @click="handleSubmit">
        Salvar Alterações
      </CButton>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import { post, put } from "@/helpers/apiRequest";
import CloseModal from "@/components/CloseModal";
import Loading from "@/components/Loading.vue";
import StepInformacoes from "../sections/StepInformacoes.vue";
import StepDestino from "../sections/StepDestino.vue";
import StepImagens from "../sections/StepImagens.vue";
import StepExibicao from "../sections/StepExibicao.vue";
import { normalizeBannerParaApi } from "../helpers/bannerDefaults";
import { campoVisivel } from "../helpers/bannerLabels";

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "*obrigatório",
  },
});

export default {
  name: "BannerFormModal",
  props: ["item", "close", "filiais", "sistemas"],
  components: {
    CloseModal,
    Loading,
    StepInformacoes,
    StepDestino,
    StepImagens,
    StepExibicao,
  },
  data() {
    return {
      loading: false,
    };
  },
  validators: {
    "item.nome": (value) => Validator.value(value).required(),
    "item.tipo": (value) => Validator.value(value).required(),
    "item.imagem_desktop": (value) => Validator.value(value).required(),
    "item.link_integrado_id, item.tipo, item.local": function (
      linkIntegradoId,
      tipo,
      local
    ) {
      if (tipo === "LINK_INTEGRADO" && campoVisivel(local, "destino")) {
        return Validator.value(linkIntegradoId).required();
      }
    },
  },
  methods: {
    prepararFormulario() {
      this.validation.reset();
    },
    handleSubmit() {
      this.$validate().then((success) => {
        if (!success) {
          return;
        }

        const normalized = normalizeBannerParaApi(this.item, this.sistemas);

        if (this.item.id) {
          this.update(normalized);
        } else {
          this.create(normalized);
        }
      });
    },
    create(item) {
      this.loading = true;
      post("/admin/marketing/banners", item)
        .then(() => {
          this.close();
        })
        .catch((err) => {
          this.$swal({
            title: "Falha ao cadastrar",
            text: err.message,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    update(item) {
      this.loading = true;
      put(`/admin/marketing/banners/${item.id}`, item)
        .then(() => {
          this.close();
        })
        .catch((err) => {
          this.$swal({
            title: "Falha ao atualizar",
            text: err.message,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>

<style>
/* Compactar formulário dentro do modal de banners */
.modalbox .tab-pane {
  padding: 14px 16px !important;
}

.modalbox .form-group {
  margin-bottom: 10px;
}
</style>
